import React, { useState } from "react";
import { api } from "../lib/api";
import { SectionHeader } from "./Top3";
import { toast } from "sonner";
import EditableLabel from "./EditableLabel";

const FIELDS = [
  { key: "done_today", label: "DONE TODAY", placeholder: "What actually shipped." },
  { key: "moved_forward", label: "MOVED FORWARD", placeholder: "What advanced but isn't finished." },
  { key: "dropped_delegated", label: "DROPPED / DELEGATED", placeholder: "Off your plate — where did it go?" },
  { key: "biggest_win", label: "BIGGEST WIN", placeholder: "One line. Something to remember." },
  { key: "first_move_tomorrow", label: "FIRST MOVE TOMORROW", placeholder: "Tomorrow's opening move." },
];

const EndOfDay = () => {
  const [values, setValues] = useState(Object.fromEntries(FIELDS.map((f) => [f.key, ""])));
  const [closed, setClosed] = useState(false);
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    setSaving(true);
    try {
      await api.postEod(values);
      setClosed(true);
      toast("Day closed", { description: "See you tomorrow, Operator." });
    } catch {
      toast("Could not close the day");
    } finally {
      setSaving(false);
    }
  };

  return (
    <section data-testid="eod-section">
      <SectionHeader
        code="07" label="CLOSE THE DAY"
        caption="End-of-day reflection. Ninety seconds. Then leave the desk."
        labelKey="section.eod.label"
        captionKey="section.eod.caption"
      />
      <div className={`op-panel p-6 md:p-8 transition-all duration-700 ${closed ? "opacity-50" : ""}`}>
        {!closed ? (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {FIELDS.map((f) => (
                <div key={f.key} className={f.key === "biggest_win" ? "md:col-span-2" : ""}>
                  <div className="op-tag mb-2">
                    <EditableLabel labelKey={`eod.${f.key}.label`} defaultText={f.label} />
                  </div>
                  <textarea
                    data-testid={`eod-${f.key}`}
                    rows={f.key === "biggest_win" ? 2 : 2}
                    value={values[f.key]}
                    onChange={(e) => setValues({ ...values, [f.key]: e.target.value })}
                    className="op-input resize-none"
                    placeholder={f.placeholder}
                  />
                </div>
              ))}
            </div>
            <div className="flex items-center justify-between pt-2">
              <span className="op-tag">CLOSE-OUT · WAR ROOM</span>
              <button
                onClick={submit}
                disabled={saving}
                data-testid="eod-submit"
                className="op-btn op-btn--primary disabled:opacity-40"
              >
                {saving ? "CLOSING…" : "CLOSE OUT TODAY"}
              </button>
            </div>
          </div>
        ) : (
          <div className="py-16 text-center" data-testid="eod-closed">
            <div className="op-ghost-number text-[120px] leading-none mb-2">EOD</div>
            <div className="op-microcopy mb-4">SESSION · CLOSED</div>
            <div className="text-white text-2xl tracking-tight">Day complete.</div>
            <div className="text-[#A0A5B5] text-sm mt-2">Leave the desk. Tomorrow's already loaded.</div>
          </div>
        )}
      </div>
    </section>
  );
};

export default EndOfDay;
